module.exports = __webpack_public_path__ + "static/media/the-hse-logo-charcoal.27800123.svg";